import { css } from '@emotion/react';

export const statusIcon = css`
  display: inline-flex;
  position: relative;

  .StatusIcon-dot {
    border: 1px solid var(--pantry-color-borderDefault);
    flex: 0 0 3.2rem;
    height: 3.2rem;
    position: relative;
    width: 3.2rem;
  }

  /* Dashed statuses drop the solid edge and get an inset SVG ring instead. */
  .StatusIcon-dot--dashed {
    border-color: transparent;
  }

  /* SVG ring inset 1px inside the 32px dot (30px outer), so the fill and glyph stay uncovered.
     stroke-dasharray sets the exact dash/gap lengths (unavailable with border-style: dashed). */
  .StatusIcon-dashedRing {
    display: block;
    height: 3.2rem;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 3.2rem;
  }

  .StatusIcon-dashedRing circle {
    fill: none;
    stroke: var(--pantry-color-borderDefault);
    stroke-dasharray: 4 3;
    stroke-width: 1.5;
  }

  .StatusIcon-solidRing {
    display: block;
    height: 4rem;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 4rem;
  }

  .StatusIcon-solidRing circle {
    fill: none;
    stroke-width: 2;
  }

  .StatusIcon-glyph {
    align-items: center;
    display: flex;
    inset: 0;
    justify-content: center;
    position: absolute;
  }
`;
